export default "__VITE_ASSET__uqJrTU7z__"